import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { reproduccionAPI, animalesAPI } from '../services/api';

const ReproduccionPage = () => {
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState('temporada');
  const [temporada, setTemporada] = useState(null);
  const [lotes, setLotes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showLoteForm, setShowLoteForm] = useState(false);
  const [showTempForm, setShowTempForm] = useState(false);
  const [animales, setAnimales] = useState({ machos: [], hembras: [] });
  const [loteForm, setLoteForm] = useState({ toro_id: '', hembras_ids: [], tipo_servicio: 'natural' });
  const [tempForm, setTempForm] = useState({ nombre: '', fecha_inicio_servicio: '', fecha_fin_servicio: '', duracion_servicio_dias: 45, fecha_inicio_paricion: '', fecha_fin_paricion: '' });

  useEffect(() => { if (user?.establecimiento_id) loadData(); }, [user]);

  const loadData = async () => {
    try {
      setLoading(true);
      const [tempRes, lotesRes, aniRes] = await Promise.allSettled([
        reproduccionAPI.getTemporada(user.establecimiento_id),
        reproduccionAPI.listarLotes(user.establecimiento_id),
        animalesAPI.getAll({ establecimiento_id: user.establecimiento_id, page_size: 200 }),
      ]);
      if (tempRes.status === 'fulfilled') setTemporada(tempRes.value.data);
      if (lotesRes.status === 'fulfilled') setLotes(lotesRes.value.data.lotes || []);
      if (aniRes.status === 'fulfilled') {
        const all = aniRes.value.data?.data || [];
        setAnimales({ machos: all.filter(a => a.sexo === 'macho'), hembras: all.filter(a => a.sexo === 'hembra') });
      }
    } catch { /**/ } finally { setLoading(false); }
  };

  const handleCreateTemporada = async (e) => {
    e.preventDefault();
    try {
      await reproduccionAPI.crearTemporada({ ...tempForm, establecimiento_id: user.establecimiento_id });
      setShowTempForm(false);
      loadData();
    } catch (err) { alert(err.response?.data?.detail || 'Error'); }
  };

  const handleCreateLote = async (e) => {
    e.preventDefault();
    try {
      await reproduccionAPI.crearLote({ ...loteForm, establecimiento_id: user.establecimiento_id });
      setShowLoteForm(false);
      setLoteForm({ toro_id: '', hembras_ids: [], tipo_servicio: 'natural' });
      loadData();
    } catch (err) { alert(err.response?.data?.detail || 'Error'); }
  };

  const toggleHembra = (id) => {
    setLoteForm(prev => {
      const ids = prev.hembras_ids.includes(id) ? prev.hembras_ids.filter(h => h !== id) : [...prev.hembras_ids, id].slice(0, 10);
      return { ...prev, hembras_ids: ids };
    });
  };

  if (loading) return <div className="p-6 flex justify-center"><div className="w-8 h-8 border-4 border-green-600 border-t-transparent rounded-full animate-spin" /></div>;

  const tabs = [
    { id: 'temporada', label: 'Temporada' },
    { id: 'lotes', label: 'Lotes Apareamiento' },
    { id: 'habilidad', label: 'Habilidad Materna' },
  ];

  return (
    <div className="p-4 sm:p-6 space-y-6" data-testid="reproduccion-page">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <h2 className="text-xl sm:text-2xl font-bold text-gray-900">Manejo Reproductivo</h2>
      </div>

      <div className="flex bg-gray-100 rounded-lg p-1 gap-1 overflow-x-auto">
        {tabs.map(t => (
          <button key={t.id} onClick={() => setActiveTab(t.id)}
            className={`px-3 sm:px-4 py-2 text-xs sm:text-sm rounded-md transition-colors whitespace-nowrap ${activeTab === t.id ? 'bg-white text-green-700 font-semibold shadow-sm' : 'text-gray-500 hover:text-gray-700'}`}
            data-testid={`repro-tab-${t.id}`}>{t.label}</button>
        ))}
      </div>

      {/* TEMPORADA */}
      {activeTab === 'temporada' && (
        <div className="space-y-4" data-testid="repro-temporada-content">
          <div className="flex justify-between items-center">
            <h3 className="text-lg font-bold">Temporada Reproductiva Activa</h3>
            <button onClick={() => setShowTempForm(true)} className="px-4 py-2 bg-green-600 text-white rounded-lg text-sm hover:bg-green-700" data-testid="new-temporada-btn">+ Nueva Temporada</button>
          </div>
          {temporada && (
            <div className="bg-white rounded-xl shadow-sm p-6">
              <h4 className="font-bold text-gray-900 mb-3">{temporada.nombre}</h4>
              <div className="grid grid-cols-2 md:grid-cols-3 gap-4 text-sm">
                <div><span className="text-gray-500">Inicio servicio:</span> <strong>{temporada.fecha_inicio_servicio}</strong></div>
                <div><span className="text-gray-500">Fin servicio:</span> <strong>{temporada.fecha_fin_servicio}</strong></div>
                <div><span className="text-gray-500">Duracion:</span> <strong>{temporada.duracion_servicio_dias} dias</strong></div>
                <div><span className="text-gray-500">Inicio paricion:</span> <strong>{temporada.fecha_inicio_paricion}</strong></div>
                <div><span className="text-gray-500">Fin paricion:</span> <strong>{temporada.fecha_fin_paricion}</strong></div>
              </div>
            </div>
          )}
          {showTempForm && (
            <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
              <div className="bg-white rounded-xl p-6 w-full max-w-lg mx-4" data-testid="temporada-form-modal">
                <h3 className="text-lg font-bold mb-4">Nueva Temporada</h3>
                <form onSubmit={handleCreateTemporada} className="space-y-3">
                  <input type="text" placeholder="Nombre" value={tempForm.nombre} onChange={e => setTempForm({...tempForm, nombre: e.target.value})} className="w-full border rounded-lg px-3 py-2 text-sm" required />
                  <div className="grid grid-cols-2 gap-3">
                    <div><label className="text-xs text-gray-500">Inicio servicio</label><input type="date" value={tempForm.fecha_inicio_servicio} onChange={e => setTempForm({...tempForm, fecha_inicio_servicio: e.target.value})} className="w-full border rounded-lg px-3 py-2 text-sm" required /></div>
                    <div><label className="text-xs text-gray-500">Fin servicio</label><input type="date" value={tempForm.fecha_fin_servicio} onChange={e => setTempForm({...tempForm, fecha_fin_servicio: e.target.value})} className="w-full border rounded-lg px-3 py-2 text-sm" required /></div>
                    <div><label className="text-xs text-gray-500">Inicio paricion</label><input type="date" value={tempForm.fecha_inicio_paricion} onChange={e => setTempForm({...tempForm, fecha_inicio_paricion: e.target.value})} className="w-full border rounded-lg px-3 py-2 text-sm" /></div>
                    <div><label className="text-xs text-gray-500">Fin paricion</label><input type="date" value={tempForm.fecha_fin_paricion} onChange={e => setTempForm({...tempForm, fecha_fin_paricion: e.target.value})} className="w-full border rounded-lg px-3 py-2 text-sm" /></div>
                  </div>
                  <div className="flex justify-end gap-2 pt-2">
                    <button type="button" onClick={() => setShowTempForm(false)} className="px-4 py-2 text-gray-600 text-sm">Cancelar</button>
                    <button type="submit" className="px-5 py-2 bg-green-600 text-white rounded-lg text-sm" data-testid="submit-temporada-btn">Crear</button>
                  </div>
                </form>
              </div>
            </div>
          )}
        </div>
      )}

      {/* LOTES */}
      {activeTab === 'lotes' && (
        <div className="space-y-4" data-testid="repro-lotes-content">
          <div className="flex justify-between items-center">
            <h3 className="text-lg font-bold">Lotes de Apareamiento (1 toro / max 10 hembras)</h3>
            <button onClick={() => setShowLoteForm(true)} className="px-4 py-2 bg-green-600 text-white rounded-lg text-sm hover:bg-green-700" data-testid="new-lote-btn">+ Nuevo Lote</button>
          </div>
          {lotes.length === 0 ? (
            <div className="bg-white rounded-xl shadow-sm p-6 text-center text-gray-500">Sin lotes registrados</div>
          ) : (
            <div className="space-y-3">
              {lotes.map(l => (
                <div key={l.id} className="bg-white rounded-xl shadow-sm p-5">
                  <div className="flex justify-between items-start">
                    <div>
                      <p className="font-bold text-gray-900">Toro: {l.toro?.VID} <span className={`ml-2 px-2 py-0.5 rounded text-xs ${l.estado === 'activo' ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-600'}`}>{l.estado}</span></p>
                      <p className="text-sm text-gray-500 mt-1">{l.cantidad_hembras} hembras | {l.tipo_servicio} | Inicio: {l.fecha_inicio}</p>
                      <div className="flex flex-wrap gap-1 mt-2">
                        {l.hembras?.map(h => (<span key={h.id} className="px-2 py-0.5 bg-pink-100 text-pink-800 rounded text-xs">{h.VID}</span>))}
                      </div>
                    </div>
                    {l.estado === 'activo' && (
                      <button onClick={async () => { await reproduccionAPI.finalizarLote(l.id); loadData(); }} className="px-3 py-1 bg-gray-100 text-gray-700 rounded text-xs hover:bg-gray-200">Finalizar</button>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
          {showLoteForm && (
            <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
              <div className="bg-white rounded-xl p-6 w-full max-w-2xl mx-4 max-h-[80vh] overflow-y-auto" data-testid="lote-form-modal">
                <h3 className="text-lg font-bold mb-4">Nuevo Lote de Apareamiento</h3>
                <form onSubmit={handleCreateLote} className="space-y-4">
                  <div>
                    <label className="text-sm font-medium text-gray-700 mb-1 block">Toro</label>
                    <select value={loteForm.toro_id} onChange={e => setLoteForm({...loteForm, toro_id: e.target.value})} className="w-full border rounded-lg px-3 py-2 text-sm" required data-testid="lote-toro-select">
                      <option value="">Seleccionar toro...</option>
                      {animales.machos.map(m => <option key={m.id} value={m.id}>{m.VID} — {m.categoria}</option>)}
                    </select>
                  </div>
                  <div>
                    <label className="text-sm font-medium text-gray-700 mb-1 block">Tipo de servicio</label>
                    <select value={loteForm.tipo_servicio} onChange={e => setLoteForm({...loteForm, tipo_servicio: e.target.value})} className="w-full border rounded-lg px-3 py-2 text-sm">
                      <option value="natural">Monta Natural</option>
                      <option value="IATF">IATF</option>
                      <option value="IA">IA</option>
                    </select>
                  </div>
                  <div>
                    <label className="text-sm font-medium text-gray-700 mb-1 block">Hembras ({loteForm.hembras_ids.length}/10 seleccionadas)</label>
                    <div className="border rounded-lg p-2 max-h-48 overflow-y-auto grid grid-cols-2 gap-1">
                      {animales.hembras.map(h => (
                        <label key={h.id} className={`flex items-center px-2 py-1 rounded text-sm cursor-pointer ${loteForm.hembras_ids.includes(h.id) ? 'bg-green-100 text-green-800' : 'hover:bg-gray-50'}`}>
                          <input type="checkbox" checked={loteForm.hembras_ids.includes(h.id)} onChange={() => toggleHembra(h.id)} className="mr-2" />
                          {h.VID} — {h.categoria}
                        </label>
                      ))}
                    </div>
                  </div>
                  <div className="flex justify-end gap-2 pt-2">
                    <button type="button" onClick={() => setShowLoteForm(false)} className="px-4 py-2 text-gray-600 text-sm">Cancelar</button>
                    <button type="submit" className="px-5 py-2 bg-green-600 text-white rounded-lg text-sm" data-testid="submit-lote-btn" disabled={!loteForm.toro_id || loteForm.hembras_ids.length === 0}>Crear Lote</button>
                  </div>
                </form>
              </div>
            </div>
          )}
        </div>
      )}

      {/* HABILIDAD MATERNA */}
      {activeTab === 'habilidad' && (
        <div className="space-y-4" data-testid="repro-habilidad-content">
          <h3 className="text-lg font-bold">Habilidad Materna</h3>
          <p className="text-sm text-gray-500">Evaluacion 24h post-parto. Score 1-5 (1=Mala, 5=Excelente). Se registra desde la ficha del animal en el historial de pariciones.</p>
          <div className="bg-white rounded-xl shadow-sm p-6">
            <div className="grid grid-cols-5 gap-3 text-center">
              {[{s:1,l:'Mala',c:'bg-red-100 text-red-800'},{s:2,l:'Regular',c:'bg-orange-100 text-orange-800'},{s:3,l:'Buena',c:'bg-yellow-100 text-yellow-800'},{s:4,l:'Muy Buena',c:'bg-green-100 text-green-800'},{s:5,l:'Excelente',c:'bg-emerald-100 text-emerald-800'}].map(i => (
                <div key={i.s} className={`${i.c} rounded-xl p-4`}>
                  <p className="text-3xl font-bold">{i.s}</p>
                  <p className="text-xs font-medium mt-1">{i.l}</p>
                </div>
              ))}
            </div>
            <p className="text-xs text-gray-400 mt-4">Criterios: Amamantamiento inmediato, proteccion del ternero, agresividad defensiva, lamido y limpieza, aceptacion al destete.</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReproduccionPage;
